<template>
    <div class="stepCont" :class="theme">
        <div class="layout">
            <h6>从迷茫到入学，只需四步</h6>
            <div class="flex-ac flex-c fw" style="gap: 20px;">
                <div v-for="(it, i) in step" class="stepItem pointer" :key="i" :style="{ background: it.background }">
                    <div class="stepTitle">{{ it.title }}</div>
                    <div class="stepText" :style="{ color: it.color }">{{ it.text }}</div>
                    <img :src="it.img" alt="">
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import {
    ref,
    computed,
    onMounted,
    onBeforeMount,
    onBeforeUnmount,
    watch,
} from "vue";


import { storeToRefs } from "pinia";
import { useStore } from "@/store";
const store = useStore();
const { theme } = storeToRefs(store);

const step = ref([
    { img: require('@/assets/img/step/step1.png'), title: '智能择校', background: '#D1E1FF', color: '#23488B', text: '专业匹配、名校择优' },
    { img: require('@/assets/img/step/step2.png'), title: '一键申请', background: '#FFE8C8', color: '#CF831A', text: '资料预审、文书生成、进度追踪' },
    { img: require('@/assets/img/step/step3.png'), title: '签证无忧', background: '#FFD1C0', color: '#9E2020', text: '全流程指导' },
    { img: require('@/assets/img/step/step4.png'), title: '保险配置', background: '#E5FFDF', color: '#4AC42E', text: '公寓预定、保险购买' },
])
</script>
<style lang="scss" scoped>
.stepCont {
    padding: 80px 0 90px;
    background: #fff;

    h6 {
        color: #393D4B;
        font-size: 24px;
        line-height: 34px;
        text-align: center;
        margin: 0 auto 48px;
    }

    .stepItem {
        height: 160px;
        box-shadow: 0px 2px 4px 0px rgba(3, 6, 51, 0.06);
        border-radius: 30px 30px 30px 30px;

        img {
            height: 100%;
        }

        .stepTitle {
            z-index: 2;
            position: absolute;
            top: 20px;
            left: 20px;
            font-weight: 600;
            font-size: 20px;
        }

        .stepText {
            z-index: 2;
            position: absolute;
            top: 60px;
            left: 20px;
            font-size: 18px;
            width: 60%;
        }

        &:hover {
            transform: translateY(-6px);
            box-shadow: 0px 4px 8px 0px rgba(3, 6, 51, 0.3);
        }

        @media (max-width: 1000px) {
            width: calc(50% - 10px);
        }
    }
}

.dark {
    background: #2C2D3B;

    h6 {
        color: #fff;
    }
}
</style>